import { render, staticRenderFns } from "./nbbankquery-add-or-update.vue?vue&type=template&id=8cae7e5e&"
import script from "./nbbankquery-add-or-update.vue?vue&type=script&lang=js&"
export * from "./nbbankquery-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports